export default function SubcategoryComponent({ formData }) {

    const flattenSubcategories = (categories) => {
        return categories?.flatMap((category) =>
            category.sub_categories.map((sub) => ({
                ...sub,
                categoryId: category.id,
                categoryTitle: category.title,
            }))
        );
    };

    const subcategoryArray = flattenSubcategories(formData?.categories);
    return (
        <div>
            {subcategoryArray?.map((item, index) => (
                <>
                    <p key={index}>{item?.title}</p>
                </>
            ))}
        </div>
    )
}
